import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { getOwnPhoto, type ProfilePhotoResponse } from '../api/profilePhoto.ts';

/** The single cache key both `AppShell.tsx`'s header avatar and `SignaturePage.tsx`'s own photo
 * panel query, matching `useSyncAccountLocale.ts`'s `LOCALE_QUERY_KEY` precedent — so an upload or
 * removal in one place (`queryClient.setQueryData`) is visible in the other without a second network
 * round trip. */
export const OWN_PHOTO_QUERY_KEY = ['profile', 'photo'] as const;

/** Called from `AppShell` — the one component only ever rendered once a session exists, matching
 * `useSyncAccountLocale`'s own "runs once, from the shell" placement — so the header avatar and the
 * signature page's panel share one fetch regardless of which mounts first. */
export function useOwnPhoto(): UseQueryResult<ProfilePhotoResponse> {
  return useQuery({
    queryKey: OWN_PHOTO_QUERY_KEY,
    queryFn: ({ signal }) => getOwnPhoto(signal),
  });
}
